import { useEffect, useState } from 'react';

const ACTIVITY_EVENTS = ['mousemove', 'mousedown', 'keydown', 'touchstart', 'scroll'];

/**
 * Resolves to true once the user has been idle for `delayMs`.
 * Stays true until the component unmounts — single-shot.
 * Activity (mouse / key / scroll / touch) resets the timer until it fires.
 */
export function useIdleTrigger(delayMs = 120_000) {
  const [fired, setFired] = useState(false);

  useEffect(() => {
    if (fired) return undefined;

    let timer = null;
    const arm = () => {
      if (timer) clearTimeout(timer);
      timer = setTimeout(() => setFired(true), delayMs);
    };

    ACTIVITY_EVENTS.forEach(ev =>
      window.addEventListener(ev, arm, { passive: true })
    );
    arm();

    return () => {
      if (timer) clearTimeout(timer);
      ACTIVITY_EVENTS.forEach(ev => window.removeEventListener(ev, arm));
    };
  }, [delayMs, fired]);

  return fired;
}
